import { createRouter, createWebHistory } from 'vue-router';
import { auth } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('../views/Home.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      component: () => import('../views/Login.vue'),
    },
    {
      path: '/admin',
      component: () => import('../views/admin/Layout.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
      children: [
        {
          path: '',
          redirect: '/admin/clients'
        },
        {
          path: 'clients',
          component: () => import('../views/admin/Clients.vue'),
          name: 'admin-clients'
        },
        {
          path: 'plans',
          component: () => import('../views/admin/Plans.vue'),
          name: 'admin-plans'
        },
        {
          path: 'neighborhoods',
          component: () => import('../views/admin/Neighborhoods.vue'),
          name: 'admin-neighborhoods'
        },
        {
          path: 'billing',
          component: () => import('../views/admin/Billing.vue'),
          name: 'admin-billing'
        },
        {
          path: 'announcements',
          component: () => import('../views/admin/Announcements.vue'),
          name: 'admin-announcements'
        },
        {
          path: 'service-requests',
          component: () => import('../views/admin/ServiceRequests.vue'),
          name: 'admin-service-requests'
        },
        {
          path: 'settings',
          component: () => import('../views/admin/Settings.vue'),
          name: 'admin-settings'
        }
      ]
    },
    {
      path: '/client',
      component: () => import('../views/client/Dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/success',
      component: () => import('../views/payment/Success.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/failure',
      component: () => import('../views/payment/Failure.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/pending',
      component: () => import('../views/payment/Pending.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
});

let authInitialized = false;

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

  // Esperar a que Firebase Auth se inicialice
  if (!authInitialized) {
    await new Promise((resolve) => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        authInitialized = true;
        unsubscribe();
        resolve(user);
      });
    });
  }

  // Recuperar la URL original si viene de una redirección de 404
  if (window.sessionStorage.redirect) {
    const redirectUrl = new URL(window.sessionStorage.redirect);
    delete window.sessionStorage.redirect;
    
    // Solo redirigir si la ruta es diferente
    if (redirectUrl.pathname !== to.path) {
      next(redirectUrl.pathname);
      return;
    }
  }

  const currentUser = auth.currentUser;

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresAdmin && currentUser) {
    // Verificar si el usuario es administrador
    const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
    const userData = userDoc.data();
    
    if (!userData || userData.role !== 'admin') {
      next('/client');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;